import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { StatusService } from '@core/services/status.service';
import { StatusEditComponent } from '@modules/status/status-edit/status-edit.component';
import { State } from '@shared/interfaces/state';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html'
})
export class StatusListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'status';
  public dataSource: MatTableDataSource<State>;
  public selection = new SelectionModel<State>(true, []);
  public statusList: Array<State> = [];
  public state: State;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public statusService: StatusService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );

          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.statusService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.statusList = [];
          result.data.forEach((element: any) => {
            this.state = { id: element.id, name: element.attributes.name };
            this.statusList.push(this.state);
          });
          if (this.statusList.length) {
            this.dataSource = new MatTableDataSource(this.statusList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: State) {
    let dialog: any;

    const data = {
      action: action,
      item: {}
    };

    if (action === this.appConfig.ACTIONS.add.id) {
      this.constants.message = this.appConfig.LANG.message.addSuccess;
    } else {
      data.item = item;
      this.constants.message = this.appConfig.LANG.message.editSuccess;
    }

    dialog = this.generalsService.modal(StatusEditComponent, data);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.generalsService.afterClosed(this, result, this.constants.message);
      });
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
